import React, {useEffect, useState, useRef} from 'react';
import deliveryScooter from "../assets/images/motorcycle-delivery.svg";
import Strings from "../Lang/strings";
import ScheduleParser from "../utils/ScheduleParser";
import swal from "../utils/swal";
import {cancel} from "../http/service";
import {ClockIcon, LocationMarkerIcon, PhoneOutgoingIcon} from "@heroicons/react/solid";
import useTrackingMaps from "../hooks/useTrackingMaps";
import useTimer from "../hooks/useTimer";
import {toggleLoader} from "../utils/helper";
import BannerWrapper from "./BannerWarrper";

const TrackingStep = ({data, setCurrentStep}) => {
    useTrackingMaps(data);
    const timerRef = useRef();
    let timerOver = useTimer(timerRef);
    const confirmCancel = () => {
        swal(Strings.cancelConfirm, "warning", true)
            .then(async (value) => {
                if (value.isConfirmed) {
                    await cancelOrder();
                }
            })
    }
    const changeStep = (stepNumber) => {
        clearInterval(window.timerId)
        setCurrentStep(stepNumber)
    }
    const cancelOrder = async () => {
        try {
            await cancel(data.url_id);
            swal(Strings.orderHasCancel, "success").then(_ => document.location.replace("/"));
        } catch (e) {
            if (e.isGeneric) {
                return;
            }
            if (e.response.status === 409) {
                swal(Strings.cannotCancel, "warning");
                return;
            }
            return swal("something went wrong while cancel your order").then((_) => {
                window.location.reload();
            });
        }

    }

    return (
        <div className={"mt-12"}>
            <div className={"flex justify-center items-center mt-12 flex-col"}>
                <img className={"w-12 text-zain-primary md:w-24"} src={deliveryScooter} alt="delivery scooter icon"/>
                <h1 className={"text-center capitalize  mt-1 text-gray-900  lg:text-2xl text-lg"}>{Strings.trackAndReplaceYourSim}</h1>
                <BannerWrapper/>
            </div>
            <div className={"mt-3 bg-white p-3 rounded"}>
                <h3 className={"capitalize  mt-1 text-gray-900  lg:text-2xl text-lg"}>{Strings.deliveryLocation}</h3>
                <div className={"flex rounded mt-1 bg-gray-100"}>
                    <div id={"mini-map"} className={"bg-black md:h-36 md:w-40 w-24 h-24"}/>
                    <section
                        className={"flex flex-col text-gray-700 text-sm md:text-lg justify-center p-3 items-center"}>
                        <h6>
                            {data.district}
                        </h6>
                        <h6>
                            <span>Home: </span>
                            <span>{data.apartment}</span>
                            <span>, </span>
                            <span>{data.building}</span>
                        </h6>
                        <h6>
                            <span>{Strings.street}: </span>
                            <span>{data.street}</span>
                        </h6>
                        <h6>
                            {data.reference_point}
                        </h6>
                    </section>
                </div>
                <section className={"mt-3"}>
                    <h3 className={"capitalize text-gray-900  lg:text-2xl text-lg"}>{Strings.deliveryTime}</h3>
                    <h3 className={"capitalize md:mt-1 text-gray-700 text-sm md:text-base "}>
                        <span>{new Date(data.expected_date).toDateString()}</span>
                        <span className={"normal-case"}> at </span>
                        <span>{ScheduleParser.expectedTimeToAmPM(data.expected_time)}</span>
                    </h3>
                </section>
                <section className={"mt-3 md:mt-5"}>
                    <div className={"flex items-center"}>
                        <h3 className={"capitalize text-gray-900  lg:text-2xl text-lg"}>{Strings.orderStatus}</h3>
                        <h3 className={"capitalize flex px-1 text-center text-gray-900  lg:text-2xl text-lg"}>
                            {
                                data.accepted ?
                                    data.driver_assigned ?
                                        <span
                                            className={"p-2.5 rounded-full px-5 text-sm bg-green-200 text-green-700"}>
                                        {data.driver_on_way ? Strings.driverAssigned : Strings.driverGoingToPickupSim}
                                    </span>

                                        : <span
                                            className={"p-2.5 rounded-full px-5 text-sm bg-yellow-200 text-yellow-700"}>{Strings.waitingForAssigningDriver}</span>

                                    : <span
                                        className={"p-2.5 rounded-full px-5 text-sm bg-yellow-200 text-yellow-700"}>{Strings.orderInReview}</span>
                            }
                        </h3>

                    </div>
                    {
                        data.driver_location ?
                            ""
                            : <small className={"text-gray-700 block mt-3"}>{Strings.driverLocationWillShow}</small>

                    }
                    <div className={"flex mt-3 md:mt-5"}>
                        <button
                            disabled={!timerOver}
                            onClick={() => window.location.reload()}
                            className={"py-2 px-3 bg-zain-primary text-white mt-2  text-sm hover:bg-purple-900 rounded"}>{Strings.updateStatus}</button>

                        {
                            data.driver_mobile && <a target="_blank" href={`tel:${data.driver_mobile}`}
                                                     className={"py-2 flex px-3 mx-2 bg-green-600 text-white mt-2  text-sm hover:bg-green-700 rounded"}>
                                <span>{Strings.callDriver}</span>
                                <span><PhoneOutgoingIcon className={"w-5  h-5"}/></span>
                            </a>
                        }
                    </div>

                    <div ref={timerRef} className={"text-sm transition mt-2  text-gray-700"}/>
                    <div id={"tracking-map"} className={"h-48 lg:h-96 md:h-96 mt-2 w-full"}>

                    </div>
                    <div className={"flex justify-center mt-3"}>
                        <button
                            disabled={data.locked}
                            onClick={() => changeStep(2)}
                            className=" py-2 flex-1 talabatey-outline  text-sm capitalize hover:bg-purple-900 transition     bg-gray-800  text-white  rounded"
                            type="button">
                            <span>{Strings.editDeliveryTime}</span>
                            <span><ClockIcon className={"w-5 mx-0.5 inline h-5"}/></span>
                        </button>
                        <button
                            disabled={data.locked}
                            onClick={() => changeStep(1)}
                            className="py-2 flex-1 talabatey-outline text-sm mx-2 capitalize hover:bg-gray-800 hover:text-white transition  border border-gray-800 text-gray-800    rounded"
                            type="button">
                            <span>{Strings.editLocation}</span>
                            <span>
                                <LocationMarkerIcon className={"w-5 mx-0.5 inline h-5"}/>
                            </span>
                        </button>

                    </div>

                    <button
                        disabled={!!data.driver_assigned}
                        onClick={() => confirmCancel()}
                        className="talabatey-outline antialiased hover:text-white mt-7 px-4 py-1 text-sm text-zain-primary border-2 border-zain-primary capitalize hover:bg-purple-900 transition  rounded"
                        type="button">{Strings.cancelOrder}</button>
                </section>
                {data.driver_assigned && <small
                    className={"mt-2 italic text-red-500 mx-2"}>*{Strings.cannotEditOrDeleteIfDriverAssigned}</small>}

            </div>
        </div>

    );

};

export default TrackingStep;
